import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


// Thunk for getting Add banners
export const getExchange_Policy = createAsyncThunk(
    'home/add-exchange_policy',
    async (_, { rejectWithValue }) => {
        try {
            const privacypolicyData = await GET(API.GET_Exchange_Policy);
            return privacypolicyData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create the slice
const Slice = createSlice({
    name: "exchangepolicy",
    initialState: {
        content: '',
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getExchange_Policy.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getExchange_Policy.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.exchangepolicy = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getExchange_Policy.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })
            
            
    },
});

export default Slice.reducer;


